<template>
  <require from="framework/html_behaviors/af-measure"></require>
  <require from="controls/bs-form-input"></require>
  <require from="controls/bs-form-select"></require>

  <div class="form-row" af-measure.bind="[{ property: 'scrollWidth', to: 460, class: 'row-cols-1' }, { property: 'scrollWidth', from: 460, class: 'row-cols-2' }]">
    <div class="col">
      <bs-form-input type="text" label="Zone name" placeholder="Type to search" value.bind="model.text & debounce:debounceMs" maxlength="100"></bs-form-input>
    </div>
    <div class="col">
      <bs-form-select label="Archive" value.bind="model.includeArchived" options.bind="archiveOptions" value-path="value" name-path="name"></bs-form-select>
    </div>
  </div>
</template>
